import { useUser } from "../useUser";

const PRO_TIERS = [
  "PRO",
  "PRO_PLUS",
  "CREATOR_PLAT",
  "SUPERSTAR",
  "INTERNAL",
  "PRO_PLAYER",
];

export const useHasProAccess = (): boolean => {
  const { allstarUser } = useUser();
  const userType = allstarUser?.user?.userGroup?.type;

  return Boolean(userType && PRO_TIERS.includes(userType));
};

export const useSubscriptionInfo = () => {
  const { allstarUser } = useUser();
  const userGroup = allstarUser?.user?.userGroup;
  const userType = userGroup?.type;

  return {
    userType,
    isProOrHigher: Boolean(userType && PRO_TIERS.includes(userType)),
    isFree: userType === "FREE",
    isEssentials: userType === "ESSENTIALS",
    isPro: userType === "PRO",
    isProPlus: userType === "PRO_PLUS",
    isCreatorPlat: userType === "CREATOR_PLAT",
    isInternal: userType === "INTERNAL",
    isActive: userGroup?.active,
    expires: userGroup?.expires,
  };
};
